import { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'material-react-toastify';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { updateUserPassword } from '../../api/User';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { sendForgotPasswordEmail } from '../../api/ForgotPassword';

interface UserPasswordWidgetProps {
  email: string;
}

export const UserPasswordWidget = (props: UserPasswordWidgetProps) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [loading, setLoading] = useState(false);

  const [clickedSave, setClickedSave] = useState(false);
  const [clickedSendMail, setClickedSendMail] = useState(false);

  const handleSave = () => {
    setLoading(true);
    updateUserPassword(props.email, password)
      .then(() => {
        toast.success('Şifre başarıyla güncellendi');
        setClickedSave(false);
        setPassword('');
        setConfirmPassword('');
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const handleSendMail = () => {
    setLoading(true);
    sendForgotPasswordEmail(props.email)
      .then(() => {
        toast.success('Şifre sıfırlama maili başarıyla gönderildi');
        setClickedSendMail(false);
        setPassword('');
        setConfirmPassword('');
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const invalidConfirm = password !== confirmPassword;

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 400,
        height: 'fit-content',
        p: 3,
        gap: 1.5,
      }}
    >
      {clickedSave && (
        <ConfirmDialog
          content='Gerçekten kullanıcının şifresini güncellemek istiyor musunuz?'
          open={clickedSave}
          onClose={() => setClickedSave(false)}
          onConfirm={handleSave}
          color='primary'
        />
      )}

      {clickedSendMail && (
        <ConfirmDialog
          content='Gerçekten kullanıcıya şifre sıfırlama linki iletmek istiyor musunuz?'
          open={clickedSendMail}
          onClose={() => setClickedSendMail(false)}
          onConfirm={handleSendMail}
          color='primary'
        />
      )}

      <Waiting open={loading} />

      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Kullanıcı Şifresi
      </Typography>
      <Divider />

      <TextField
        label='Yeni Şifre'
        variant='outlined'
        size='small'
        value={password}
        type='password'
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
      />

      <TextField
        label='Yeni Şifre (Tekrar)'
        variant='outlined'
        size='small'
        value={confirmPassword}
        type='password'
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
        error={invalidConfirm}
        helperText={invalidConfirm ? 'Şifreler uyuşmuyor' : undefined}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        <Button
          onClick={() => setClickedSendMail(true)}
          sx={{ ...sharedStyles.buttonText }}
        >
          Sıfırlama Linki Gönder
        </Button>

        <Button
          variant='contained'
          onClick={() => setClickedSave(true)}
          sx={{ ...sharedStyles.buttonText }}
          disabled={invalidConfirm}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
